/* BBQ owns its native tag/price URLs and section-rendered results. No catalog mutations. */
(() => {
  document.querySelectorAll('[data-bbq-filters]').forEach(root => {
    if (root.dataset.ready) return;
    const grid = document.querySelector('[data-efxc][data-bbq-collection]');
    if (!grid) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const base = new URL(root.dataset.base, location.origin);
    const selects = [...root.querySelectorAll('[data-bbq-tag]')];
    const price = root.querySelector('[data-bbq-price]');
    const sort = root.querySelector('[data-bbq-sort]');
    const initialSort = sort.value || sort.options[0]?.value || 'manual';
    let appliedSort = initialSort;
    const controls = [...selects, price];
    const dialog = root.querySelector('[data-bbq-dialog]');
    const opener = root.querySelector('[data-bbq-open]');
    const quick = root.querySelector('[data-bbq-quick]');
    const groups = [], quickButtons = [], cache = new Map();
    const carry = ['preview_theme_id', '_ab', '_fd', '_sc'];
    let appliedUrl = new URL(location.href), lastFocus = null, previousOverflow = null;
    let request = null, availability = null, sequence = 0;
    const status = document.createElement('p');
    status.className = 'ef-bbq-filters__status'; status.setAttribute('role', 'status');
    root.querySelector('.ef-bbq-filters__bar').after(status);
    const tagsOf = url => url.pathname.slice(base.pathname.length).replace(/^\//, '').split('+').filter(Boolean).map(decodeURIComponent).map(tag => tag.replace(/^ef-bbq-install-/, 'bbq-install-'));
    function clearUrl() {
      const url = new URL(base);
      carry.forEach(key => { if (appliedUrl.searchParams.has(key)) url.searchParams.set(key, appliedUrl.searchParams.get(key)); });
      url.searchParams.set('sort_by', sort.value);
      return url;
    }
    function buildUrl(overrideControl, overrideValue) {
      const url = clearUrl();
      const retained = tagsOf(appliedUrl).filter(tag => !selects.some(control => tag.startsWith(control.dataset.bbqTag)));
      const tags = [...retained, ...selects.map(control => control === overrideControl ? overrideValue : control.value).filter(Boolean)];
      if (tags.length) url.pathname += '/' + tags.map(encodeURIComponent).join('+');
      const [lo, hi] = (overrideControl === price ? overrideValue : price.value).split(':');
      if (lo) url.searchParams.set('filter.v.price.gte', lo);
      if (hi) url.searchParams.set('filter.v.price.lte', hi);
      return url;
    }
    function restoreApplied() {
      const tags = tagsOf(appliedUrl);
      selects.forEach(control => { control.value = tags.find(tag => [...control.options].some(option => option.value === tag)) || ''; });
      const lo = appliedUrl.searchParams.get('filter.v.price.gte') || '';
      const hi = appliedUrl.searchParams.get('filter.v.price.lte') || '';
      const value = lo || hi ? (lo || '0') + ':' + hi : '';
      if (value && ![...price.options].some(option => option.value === value)) price.add(new Option(`$${lo || '0'}${hi ? '–$' + hi : ' & up'}`, value));
      price.value = value;
      sync();
    }
    function sync() {
      groups.forEach(({control, buttons}) => buttons.forEach(button => {
        const active = control.value === button.dataset.bbqValue;
        button.setAttribute('aria-pressed', String(active));
        if (active || !button.dataset.bbqValue) { button.disabled = false; button.title = ''; }
      }));
      const tags = tagsOf(appliedUrl);
      const selected = tags.length + Number(appliedUrl.searchParams.has('filter.v.price.gte') || appliedUrl.searchParams.has('filter.v.price.lte'));
      if (quickButtons.length) {
        const control = quickButtons[0].control;
        const options = [...control.options].filter(option => option.value), shown = options.slice(0, 5);
        const active = options.find(option => tags.includes(option.value));
        if (active && !shown.includes(active)) shown[shown.length - 1] = active;
        quickButtons.forEach((item, index) => { const option = shown[index]; if (option) { item.value = option.value; item.button.textContent = option.textContent; item.button.dataset.bbqQuickValue = option.value; } });
      }
      quickButtons.forEach(({button, value}) => {
        button.setAttribute('aria-pressed', String(tags.includes(value)));
        if (tags.includes(value)) { button.disabled = false; button.title = ''; }
      });
      root.querySelector('[data-bbq-badge]').textContent = selected || '';
      root.querySelector('[data-bbq-active]').textContent = selected ? `${selected} active filter${selected === 1 ? '' : 's'}` : '';
      root.querySelector('[data-bbq-clear]').href = clearUrl().pathname + clearUrl().search;
      const all = quick.querySelector('[data-bbq-all]');
      if (all) { all.setAttribute('aria-current', String(!selected)); all.href = clearUrl().pathname + clearUrl().search; }
    }
    function stopAvailability() { availability?.abort(); availability = null; }
    async function refreshAvailability() {
      stopAvailability();
      const ac = new AbortController(); availability = ac;
      const candidates = dialog.open
        ? groups.flatMap(({control, buttons}) => buttons.map(button => ({control, value:button.dataset.bbqValue, button})))
        : quick.getClientRects().length ? quickButtons : [];
      candidates.forEach(({control, value, button}) => {
        button.disabled = false; button.title = '';
        const option = [...control.options].find(item => item.value === value); if (option) option.disabled = false;
      });
      const queue = candidates.filter(({control, value}) => value && control.value !== value);
      async function worker() {
        while (queue.length && !ac.signal.aborted) {
          const item = queue.shift();
          const url = buildUrl(item.control, item.value);
          url.searchParams.delete('sort_by'); url.searchParams.set('section_id', 'ef-collection-summary-data');
          const key = url.pathname + url.search;
          let total = null;
          try {
            const cached = cache.get(key);
            if (cached && Date.now() - cached.at < 60000) total = cached.total;
            else {
              const response = await fetch(url, {signal:ac.signal});
              if (!response.ok) throw Error('Unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const data = JSON.parse(doc.querySelector('script[data-ef-summary-source]')?.textContent || 'null');
              if (data && Number.isInteger(data.total) && data.total >= 0) { total = data.total; cache.set(key, {total, at:Date.now()}); }
            }
          } catch (error) { if (error.name === 'AbortError') return; }
          if (ac.signal.aborted) return;
          const unavailable = total === 0 && item.control.value !== item.value;
          item.button.disabled = unavailable;
          item.button.title = unavailable ? 'No matching products with these filters' : '';
          const option = [...item.control.options].find(option => option.value === item.value);
          if (option) option.disabled = unavailable;
        }
      }
      await Promise.all([worker(), worker()]);
    }
    const results = () => grid.querySelector('[data-efxc-swap="results"]');
    async function navigate(input, {push = true, append = false} = {}) {
      const target = new URL(input, location.origin);
      carry.forEach(key => { if (!target.searchParams.has(key) && appliedUrl.searchParams.has(key)) target.searchParams.set(key, appliedUrl.searchParams.get(key)); });
      request?.abort(); stopAvailability();
      const ac = new AbortController(); request = ac; const token = ++sequence;
      const url = new URL(target); url.searchParams.set('section_id', grid.dataset.sectionId);
      status.classList.remove('is-error'); status.textContent = 'Updating products…'; results()?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, {signal:ac.signal});
        if (!response.ok) throw Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('[data-efxc][data-bbq-collection]');
        const nextResults = next?.querySelector('[data-efxc-swap="results"]');
        if (!nextResults) throw Error('Results missing');
        if (token !== sequence) return;
        if (append) {
          const items = nextResults.querySelector('[data-efxc-grid]');
          const current = grid.querySelector('[data-efxc-grid]');
          if (!items || !current) throw Error('Products missing');
          const added = [...items.children]; current.append(...added);
          const more = results().querySelector('.efxc-more'), nextMore = nextResults.querySelector('.efxc-more');
          if (more && nextMore) more.replaceWith(nextMore);
          else more?.remove();
          added[0]?.querySelector('a')?.focus({preventScroll:true});
        } else {
          results().replaceWith(nextResults);
          appliedUrl = target;
          sort.value = target.searchParams.get('sort_by') || next.dataset.sort || initialSort;
          appliedSort = sort.value;
          restoreApplied();
          const count = doc.querySelector('.ef-bbq-filters__count');
          if (count) root.querySelector('.ef-bbq-filters__count').textContent = count.textContent;
          grid.dataset.tags = next.dataset.tags || ''; grid.dataset.sort = next.dataset.sort || '';
          if (push && target.href !== location.href) history.pushState({bbq:true}, '', target.pathname + target.search);
          if (dialog.open) dialog.close();
        }
        status.textContent = 'Products updated.';
        grid.dispatchEvent(new CustomEvent('ef:collection:updated', {bubbles:true}));
      } catch (error) {
        if (error.name === 'AbortError') return;
        restoreApplied();
        sort.value = appliedSort;
        status.classList.add('is-error'); status.textContent = 'Products could not be updated. Please try again.';
      } finally {
        if (token === sequence) { results()?.setAttribute('aria-busy', 'false'); request = null; refreshAvailability(); }
      }
    }
    restoreApplied();
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.close();
      controls.forEach(control => {
        const group = control.closest('.ef-bbq-filters__group'), label = group.querySelector('label');
        const choices = document.createElement('div'); choices.className = 'ef-bbq-filters__choices';
        choices.setAttribute('role', 'group'); choices.setAttribute('aria-labelledby', label.id);
        const buttons = [...control.options].map(option => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'ef-bbq-filters__chip';
          button.textContent = option.value ? option.textContent : 'All'; button.dataset.bbqValue = option.value;
          button.addEventListener('click', () => { control.value = control.value === option.value ? '' : option.value; sync(); refreshAvailability(); });
          choices.append(button); return button;
        });
        group.append(choices); control.hidden = true; groups.push({control, buttons});
      });
      const all = document.createElement('a'); all.className = 'ef-bbq-filters__chip'; all.textContent = 'All'; all.dataset.bbqAll = ''; quick.append(all);
      const control = ['bbq-kind-', 'bbq-install-', 'bbq-fuel-', 'bbq-brand-'].map(prefix => selects.find(select => select.dataset.bbqTag === prefix)).find(select => select && select.options.length > 2);
      if (control) {
        const options = [...control.options].filter(option => option.value), shown = options.slice(0,5);
        const active = options.find(option => option.value === control.value); if (active && !shown.includes(active)) shown[shown.length - 1] = active;
        shown.forEach(option => {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'ef-bbq-filters__chip';
          button.textContent = option.textContent; button.dataset.bbqQuickValue = option.value;
          const item = {control, value:option.value, button};
          button.addEventListener('click', () => { restoreApplied(); control.value = control.value === item.value ? '' : item.value; navigate(buildUrl()); });
          quick.append(button); quickButtons.push(item);
        });
      }
      opener.addEventListener('click', () => {
        lastFocus = document.activeElement; restoreApplied(); previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden'; dialog.showModal(); root.querySelector('[data-bbq-close]').focus(); refreshAvailability();
      });
      root.querySelector('[data-bbq-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => {
        restoreApplied(); if (previousOverflow !== null) document.documentElement.style.overflow = previousOverflow;
        previousOverflow = null; if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true}); refreshAvailability();
      });
      root.dataset.uiReady = 'true';
    }
    sync();
    form.addEventListener('submit', event => { event.preventDefault(); navigate(buildUrl()); });
    sort.addEventListener('change', () => { restoreApplied(); navigate(buildUrl()); });
    root.addEventListener('click', event => {
      const clear = event.target.closest('[data-bbq-all],[data-bbq-clear]');
      if (clear && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) { event.preventDefault(); navigate(clearUrl()); }
    });
    grid.addEventListener('click', event => {
      const link = event.target.closest('a[data-efxc-page], .efxc-pagination a');
      const more = event.target.closest('[data-efxc-loadmore]');
      if ((link || more) && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.preventDefault(); event.stopImmediatePropagation();
        const pageUrl = new URL(link ? link.href : more.dataset.url, location.origin);
        const target = new URL(appliedUrl); target.searchParams.set('page', pageUrl.searchParams.get('page') || '1');
        navigate(target, {append:!!more, push:!more});
      }
    }, true);
    window.addEventListener('popstate', () => { if (new URL(location.href).pathname.startsWith(base.pathname)) navigate(location.href, {push:false}); });
    new MutationObserver(() => { if (!request) refreshAvailability(); }).observe(root, {attributes:true, attributeFilter:['data-ef-quick-open']});
    window.addEventListener('resize', () => { if (!request) refreshAvailability(); });
    refreshAvailability();
  });
})();
